import { IExample } from "../../../Components/Examples.Types";

import FilterExample from "./examples/Filter.Example";
import FilterCustomSearchExample from "./examples/Filter.CustomSearch.Example";
import FilterDefaultStateExample from "./examples/Filter.DefaultState.Example";
import FilterBarExample from "./examples/FilterBar.Example";
import personaFemaleImage from "./examples/persona-female.png";

export default [
    {
        title: "Basic filter",
        component: FilterExample,
        code: require("!raw-loader!./examples/Filter.Example.tsx"),
        stretchContainer: true,
        dependencies: {
            "Data.ts": require("!raw-loader!./examples/Data.ts")
        }
    },
    {
        title: "Filter with default state",
        component: FilterDefaultStateExample,
        code: require("!raw-loader!./examples/Filter.DefaultState.Example.tsx"),
        stretchContainer: true,
        dependencies: {
            "Data.ts": require("!raw-loader!./examples/Data.ts")
        }
    },
    {
        title: "Filter with custom search",
        component: FilterCustomSearchExample,
        code: require("!raw-loader!./examples/Filter.CustomSearch.Example.tsx"),
        stretchContainer: true,
        dependencies: {
            "Data.ts": require("!raw-loader!./examples/Data.ts")
        }
    },
    {
        title: "Basic filter bar",
        component: FilterBarExample,
        code: require("!raw-loader!./examples/FilterBar.Example.tsx"),
        dependencies: {
            "Data.ts": require("!raw-loader!./examples/Data.ts"),
            "persona-female.png": personaFemaleImage
        },
        stretchContainer: true
    }
] as IExample[];
